import { FormItem } from '../../base-data/area-building/model/form-item-interface';


export const UNIT_SIGNED_STATUS_FORM: FormItem[] = [
  { text: 'Common.ToBeApproved', value: 'waitting', num: 0 },
  { text: 'Common.Approved', value: 'signed', num: 1 }
]
export const UNIT_SIGNED_SIGN_FROM: FormItem[] = [
  { text: 'ApplyingUnit.PMApproval', value: 'step1', num: 1 },
  { text: 'ApplyingUnit.DeptApproval', value: 'step2', num: 2 },
  { text: 'ApplyingUnit.BudgetsApproval', value: 'step10', num: 9 }
]
// dubget
export const UNIT_BUDGET_SIGN_ITEM: FormItem[] = [
  { text: 'Common.GeneralEngineering', value: '0', num: 0 },
  { text: 'Common.ProjectEngineering', value: '1', num: 1 },
];